import React, {ChangeEvent, useEffect, useState} from "react";

import "./BankOfAmericaCVVInput.scss";
import {BankOfAmericaFlexMicroform} from "../../../../context/BankOfAmericaContext";

interface BankOfAmericaCVVProps {
    bankOfAmericaFlexMicroform: BankOfAmericaFlexMicroform;
}

export const BankOfAmericaCVVInput: React.FunctionComponent<BankOfAmericaCVVProps> = (props) => {
    useEffect(() => {
        if (props.bankOfAmericaFlexMicroform) {
            const numberField = props.bankOfAmericaFlexMicroform.createField('securityCode', {
                maxLength: 4,
                placeholder: ''
            });
            numberField.load('#bank-of-america-cvv-container');
        }
    }, [props.bankOfAmericaFlexMicroform]);

    return <div className="bank-of-america-cvv-container" id="bank-of-america-cvv-container">
    </div>
}
